import React from "react";

type Props = {
  children: React.ReactNode;
  hideNavbar?: boolean;
};

const PageLayout = (props: Props): React.ReactElement => {
  const { hideNavbar } = props;
  const url: string = window.location.pathname;

  return (
    <>
      {url === "/" ? null : (
        // Matches responsiveAppBarStyles.appBar's actual fixed height (70px) —
        // this was 45px, silently clipping the top ~25px of every page's
        // content under the fixed header.
        <div style={{ height: !hideNavbar ? "70px" : 0, width: "100%" }} />
      )}
      {props.children}
    </>
  );
};

export default PageLayout;
